import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

type Variant = "primary" | "ghost" | "danger" | "default";

export function Button({
  children,
  variant = "default",
  className = "",
  ...rest
}: PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }
>) {
  const v =
    variant === "primary"
      ? "btn btn-primary"
      : variant === "danger"
        ? "btn btn-danger"
        : variant === "ghost"
          ? "btn btn-ghost"
          : "btn";
  return (
    <button type="button" className={`${v} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
